import { commonTexts, settlementTexts } from 'consts/text';
import { formFields } from 'consts/form/formFields';
import { DiscountApplyType, DiscountTarget, ExtraLessonsOptionsDTO } from 'types';
import { AppBaseSelect, AppFormItem, AppInput } from 'components/atoms';
import { DayPeriodPickerElement } from 'components/molecules';
import { CurrencyInputElement } from '../../molecules/FormElements/CurrencyInputElement/CurrencyInputElement';
import { PercentageInputElement } from '../../molecules/FormElements/PercentageInputElement/PercentageInputElement';

const extraLessonField = (
    discountTarget: DiscountTarget,
    options: ExtraLessonsOptionsDTO | undefined,
    isFetchingOptions: boolean,
) =>
    discountTarget === DiscountTarget.EXTRA_LESSONS && (
        <AppFormItem
            label={settlementTexts.discounts.addEditForm.chooseExtraLesson}
            name={formFields.courseId}
        >
            <AppBaseSelect
                options={
                    options
                        ? options.map((option) => ({ value: option.id, label: option.name }))
                        : []
                }
                loading={isFetchingOptions}
            />
        </AppFormItem>
    );

const datePickerComponents = () => (
    <>
        <DayPeriodPickerElement
            mode="start"
            endField={formFields.endDate}
            startField={formFields.startDate}
            label={settlementTexts.discounts.addEditForm.discountStartDate}
        />
        <DayPeriodPickerElement
            mode="finish"
            endField={formFields.endDate}
            startField={formFields.startDate}
            label={settlementTexts.discounts.addEditForm.discountEndDate}
        />
    </>
);

const monthDatePickerComponents = () => (
    <>
        <DayPeriodPickerElement
            mode="start"
            endField={formFields.endDate}
            startField={formFields.startDate}
            label={settlementTexts.discounts.addEditForm.discountStartDate}
            placeholder={commonTexts.actionLabels.selectMonth}
            picker="month"
            format="MMMM"
        />
        <DayPeriodPickerElement
            mode="finish"
            endField={formFields.endDate}
            startField={formFields.startDate}
            label={settlementTexts.discounts.addEditForm.discountEndDate}
            placeholder={commonTexts.actionLabels.selectMonth}
            picker="month"
            format="MMMM"
        />
    </>
);

export const discountFields = (
    discountTarget: DiscountTarget,
    applyType: DiscountApplyType,
    isAmountBasedDiscount: boolean,
    options: ExtraLessonsOptionsDTO | undefined,
    isFetchingOptions: boolean,
) => {
    const isFullMonthsMode = applyType === DiscountApplyType.CATEGORY;

    const amountFormItem = isAmountBasedDiscount ? (
        <CurrencyInputElement
            label={settlementTexts.discounts.addEditForm.discountAmount}
            name={formFields.amount}
            isHalfParentWidth
        />
    ) : (
        <PercentageInputElement
            label={settlementTexts.discounts.addEditForm.discountAmount}
            name={formFields.amount}
            isHalfParentWidth
        />
    );

    return (
        <>
            {extraLessonField(discountTarget, options, isFetchingOptions)}
            <AppFormItem
                label={settlementTexts.discounts.addEditForm.discountName}
                name={formFields.name}
            >
                <AppInput />
            </AppFormItem>
            <AppFormItem justifyContent="space-between" doubleItem>
                {isFullMonthsMode ? monthDatePickerComponents() : datePickerComponents()}
            </AppFormItem>
            {amountFormItem}
        </>
    );
};
